let html = `<div class="full-episode selector layer--visible">
    <div class="full-episode__img">
        <img />
    </div>

    <div class="full-episode__body">
        <div class="full-episode__num">{num}</div>
        <div class="full-episode__name">{name}</div>
        <div class="full-episode__date">{date}</div>
    </div>
</div>`

export default html